import React, { useState, useEffect} from 'react'
import useReactRouter from "use-react-router";
import { Formik } from 'formik'
import { useLazyQuery } from '@apollo/react-hooks'

import { Breadcrumb, Container, Row, Form, Col, Image, Button } from 'react-bootstrap'
import { FaEye, FaEdit, FaTrash, FaPlusCircle } from "react-icons/fa";
import Consts from "../../../../consts"

import {POST_CATEGORY} from "../../../../apollo/post/Query"

import { Title, CustomButton } from "../../../../common"
import CUSD_POST_CATEGORY from '../../../../crud/PostCategory';


function PostCategoryUpdate() {
    const { history,location,match } = useReactRouter();
    let id = match?.params?.id

    //state
    const {
        _updatePostCategory,
    } = CUSD_POST_CATEGORY();

    const [loadData, {data:postData}] = useLazyQuery(POST_CATEGORY,{fetchPolicy: "network-only"})


    // useEffect
    useEffect(() => {
        if(id){
         loadData({
            variables: {
                where: {
                    id:id
                }
            }
         })
        }
    },[id])


    // function
    const _settingMenu = () => { history.push(Consts.PAGE_SETTING_MENU) }

    return (
        <div>
            <Breadcrumb style={{ marginTop: 60, fontSize: '12px' }}>
                <Breadcrumb.Item href="#" onClick={() => _settingMenu()}>Settings</Breadcrumb.Item>
                <Breadcrumb.Item active>Post Category Add</Breadcrumb.Item>
            </Breadcrumb>

            <div style={Consts.MAIN_CARD} >
                <Title text='Post Category Add' />
                <hr></hr>

                {postData && (

                <Formik
                    initialValues={{
                        postCategoryName:postData?.categoryPost?.name ?? " ",
                        detail:postData?.categoryPost?.detail ?? " ",
                    }}
                    validate={values => {
                        const errors = {}
                        if (!values.postCategoryName) {
                          errors.postCategoryName = 'Please input post category name ....'
                        }
                        return errors
                    }}
                    onSubmit={values => {
                        let _data ={
                            id:postData?.categoryPost?.id,
                            name: values?.postCategoryName,
                            detail:values?.detail,

                        }
                        _updatePostCategory(_data,postData?.categoryPost )
                    }}
                >
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting
                        /* and other goodies */
                    }) => (

                        <Row>
                        
                            <Col md={12}>
                                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                    <Form.Label style={{fontSize:14}}>certificate category name <span style={{ color: "red" }}>*</span></Form.Label>
                                    <Form.Control
                                        size='lg'
                                        type="text"
                                        placeholder="Please post category name"
                                        name="postCategoryName"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.postCategoryName}
                                        style={{ height:40,fontSize:14}}
                                    />
                                    <div style={{ color: 'red' }}>
                                        <p>{errors.postCategoryName && touched.postCategoryName && errors.postCategoryName}</p>
                                    </div>
                                </Form.Group>

                                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                    <Form.Label style={{fontSize:14}}>Detail</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        placeholder="if any detail..."
                                        name="detail"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.detail}
                                        style={{ height: '100px',fontSize:14 }}
                                    />
                                </Form.Group>
                                
                                <center>
                                    <CustomButton cancel title='Cancel' style={{ width: "199px", height: '44px', border: 0 }} onClick={() => history.goBack()}/>
                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                    <CustomButton addIcon title='Save' style={{ width: "199px", height: '44px' }} onClick={()=>handleSubmit()}/>
                                </center>
                            </Col>
                        </Row>
                    )}
                </Formik>
                )}
            </div>
        </div>
    )
}
export default PostCategoryUpdate